import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { fadeUp, viewportOnce } from "@/lib/motion";

const FAQS = [
  {
    q: "Is the class really free?",
    a: "Yes — 100% free to attend. The #AskTasha Home Health Care Agency Class Series is a live webinar you can join every Thursday at 7PM EST on Zoom. Just save your seat.",
  },
  {
    q: "Do I need a clinical or medical background?",
    a: "Not at all. You don't need to be a nurse to own an agency. You need the right structure, systems, and people around you — leadership is the skill that matters most, and that's exactly what we teach.",
  },
  {
    q: "What will I actually learn?",
    a: "Industry credentials (NPI, NPPES, CAQH, OIG), the three payer pathways (Private Pay, Medicaid/Waiver, Medicare-Certified), client documentation essentials, a 7-step launch roadmap, and a readiness self-assessment — all in plain English.",
  },
  {
    q: "How often does the class run?",
    a: "Every Thursday at 7PM EST, live. The syllabus changes weekly, so each session builds on real, current material — and includes a live Q&A where your specific questions get answered.",
  },
  {
    q: "Is this legal, medical, or financial advice?",
    a: "No. The class and this site provide general educational information to help you understand the industry. For guidance specific to your state and situation, join a live session or reach out directly.",
  },
  {
    q: "How do I get personalized help?",
    a: "Join a live #AskTasha session and bring your questions, or email contact@gotoasktasha.com to talk about working together on your launch.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative border-y border-cream/10 bg-ink-elevated py-20 md:py-32">
    <div className="container-tasha grid gap-14 lg:grid-cols-[0.7fr_1.3fr]">
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} className="lg:sticky lg:top-28 lg:self-start">
        <span className="overline">Questions</span>
        <h2 className="mt-5 font-serif text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
          Frequently <span className="font-script text-gold">asked</span>
        </h2>
        <p className="mt-6 font-sans text-lg font-light text-cream/70">
          Everything you need to know before you join us live.
        </p>
      </motion.div>

      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce}>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-cream/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 text-left font-serif text-xl font-medium text-cream hover:text-gold hover:no-underline md:text-2xl [&>svg]:text-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 font-sans text-base font-light leading-relaxed text-cream/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);

export default Faq;
